import React from 'react';
import { Navigate } from 'react-router-dom';

/**
 * RedirectPage component that handles root path ('/') routing
 * Always redirects to /home regardless of authentication status
 * The /home route itself is protected and will handle authentication checks
 */
const RedirectPage: React.FC = () => {
  // Always redirect to /home - let the protected route handle authentication
  return <Navigate to="/home" replace />;
};

export default RedirectPage;
